module.exports = __webpack_public_path__ + "img/hubbel-sketch2.3a169bf4.png";